import { createSlice } from "@reduxjs/toolkit";
import {       contractNote_zipThunk } from "./thunk";


export const initialState = {
  contractNote_zipData: [],
  contractNote_zipError: {
    code: null,
    message: '',
    data: null
  },
  contractNote_zipLoading: false,
  
  
};

const ContractNote_Zip = createSlice({
  name: "ContractNote_Zip",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(contractNote_zipThunk.pending, (state) => {
      state.contractNote_zipLoading = true ;
      state.contractNote_zipError = initialState.contractNote_zipError; 
  });
    builder.addCase(contractNote_zipThunk.fulfilled, (state, action) => {
        state.contractNote_zipData = action.payload.data;
        state.contractNote_zipLoading = false ;
    });
    builder.addCase(contractNote_zipThunk.rejected, (state, action) => {
      state.contractNote_zipError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.contractNote_zipLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = ContractNote_Zip.actions

export default ContractNote_Zip.reducer;